import React, { useMemo, useState } from "react";
import { Table } from "react-bootstrap";
import "../editlocationdetails/EditLocationNames.css";
import EditLocationRadioButtons from "../../components/editlocationdetails/EditLocationRadioButtons";
import ApproveDenyAllToggle from "./ApproveDenyAllToggle";

export default function PendingLocationNameEdits(props) {
  const pendingEdits = useMemo(() => { return props.pendingEdits }, [props]);
  
  function handleApproveDeny(target){
    props.handleApproveDeny(target, "locationName");
  }

  function handleReviewedAllCheck(checked){
    props.handleReviewedAllCheck(checked, "locationName");
  }
  
  return (
    <div className="edit-details-body">
      <div className="edit-details-title">Original Location Name</div>
      {props.mainName ? 
        <p className="original-data-text">{props.mainName}</p> : <p className='location-details-nodata'>NO DATA AVAILABLE</p>}    
      <div className="pending-edits-body-margin">
        {pendingEdits?.length > 0 ? (
            <>
            <div className="edit-details-title">Location Name Edits</div>
            <ApproveDenyAllToggle 
              handleApproveDenyAll={handleApproveDeny} 
              reviewedAll={props.reviewedAll.reviewedAll} 
              approveDenyAll={props.reviewedAll.approvedAll}
              handleReviewedAllCheck={handleReviewedAllCheck}
            />
            <div className="location-pending-edits-table">
                <Table className="floating-table">
                    <thead>
                        <tr>
                            <th className="edits-table-th-first">Editor Username</th>                           
                            <th>Time Stamp ({props.userTimeZone})</th>
                            <th>Location Name</th>                      
                            <th style={{ textAlign: "center", paddingRight: '4%'}}>Review Edits</th>
                        </tr>
                    </thead>               
                    <tbody>
                            {pendingEdits.map((item, index) =>
                            <tr key={item.editId}>
                                <td className="edits-table-td-first">{item.editAddedBy}</td>                                
                                <td>{props.convertTimeToLocal(item.editAddedDate)}</td>
                                <td className="edited-content">{item.locationName}</td>
                                <td style={{ textAlign: "center", paddingRight: '4%'}}>
                                  <EditLocationRadioButtons 
                                      radioName={item.editId}
                                      radioIndex={index}
                                      radioOptions={props.toggleOptions}
                                      radioChecked={item.approved !== undefined ? item.approved : null}
                                      defaultValue={null}
                                      useToggle={true}
                                      onRadioChange={handleApproveDeny}
                                  />
                                </td>
                            </tr>
                        )}
                    </tbody>                 
                    </Table>
                </div>
            </>
        ) :
        (
            <div className="edit-details-title">
                *** No Edits to review ***
            </div>
        )}       
      </div>
    </div>
  );
}